import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaymentDetailModule } from '@common/components';
import { FareRulesDetailModule } from '@common/components/modals/my-booking-itinerary/fare-rules-detail/fare-rules-detail.module';
import { SharesModule } from '@common/components/modals/my-booking-itinerary/shares/shares.module';
import { MilesFormatPipe } from '@common/pipes/miles-format/miles-format.pipe';
import { GetFareConditionsStoreService } from '@common/services/my-booking/get-fare-conditions/get-fare-conditions.service';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { MyBookingItineraryPresModule } from '../presenter/my-booking-itinerary-pres.module';
import { MyBookingItineraryContComponent } from './my-booking-itinerary-cont.component';

@NgModule({
  declarations: [MyBookingItineraryContComponent],
  imports: [CommonModule, MyBookingItineraryPresModule, FareRulesDetailModule, SharesModule, PaymentDetailModule],
  exports: [MyBookingItineraryContComponent],
  providers: [GetFareConditionsStoreService, MyBookingItineraryService, MilesFormatPipe],
})
export class MyBookingItineraryContModule {}
